export default __webpack_public_path__ + "66507b120b87a2604a1f9ee6d1e1c1d3.png";